import { Link } from 'react-router-dom';

export default function Hero() {
  const stats = [
    { value: '500+', label: 'Patients Treated' },
    { value: '4+', label: 'Years Experience' },
    { value: '98%', label: 'Success Rate' },
  ];

  return (
    <section id="home" className="relative min-h-screen flex flex-col justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/93017206-e53a-40a0-b3f7-6964e97b7467/ce36accd-a74b-4d26-baac-278c21ee4ca9_physiotherapist-helping-female-patient-her-clinic.jpg?v=8174fe5ce3e12c681c9ed1f453b441c8"
          alt="Aura Align Physio Clinic"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/40 to-black/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-16 pt-28 sm:pt-32 pb-20 sm:pb-24">
        <div className="max-w-2xl space-y-6 sm:space-y-8">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/25 text-white text-sm font-medium">
            <span className="w-2 h-2 rounded-full bg-teal-400 animate-pulse"></span>
            Clontarf, QLD — Accepting New Patients
          </div>

          <div className="space-y-3">
            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white leading-[1.05]" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
              Move Better.<br />
              <span style={{ color: '#5ECFCF' }}>Live Better.</span>
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-white/85 leading-relaxed max-w-xl pt-2">
              Expert physiotherapy care tailored to you — restoring balance, enhancing movement, and empowering your long-term wellness.
            </p>
          </div>

          <div className="flex flex-wrap gap-3 sm:gap-4 pt-2">
            <Link
              to="/booking"
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 rounded-full font-semibold text-white text-sm sm:text-base transition-all hover:scale-105 hover:shadow-2xl cursor-pointer"
              style={{ backgroundColor: '#FF6B6B' }}
            >
              <i className="ri-calendar-check-line text-base sm:text-lg"></i>
              Book Appointment
            </Link>
            <button
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="whitespace-nowrap inline-flex items-center gap-2 px-6 sm:px-8 py-3 sm:py-4 rounded-full border-2 border-white/70 text-white font-semibold text-sm sm:text-base hover:bg-white hover:text-teal-800 transition-all cursor-pointer backdrop-blur-sm"
            >
              Explore Services
              <i className="ri-arrow-down-line text-base sm:text-lg"></i>
            </button>
          </div>

          <div className="flex flex-wrap gap-3 sm:gap-4 pt-2">
            {[
              { icon: 'ri-shield-check-line', text: 'AHPRA Registered' },
              { icon: 'ri-map-pin-line', text: 'Clontarf QLD' },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-sm">
                <i className={`${badge.icon} text-teal-300`}></i>
                {badge.text}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 w-full border-t border-white/15 backdrop-blur-md bg-black/25">
        <div className="max-w-7xl mx-auto px-6 lg:px-16 py-5 sm:py-6 flex flex-wrap justify-center lg:justify-start gap-8 sm:gap-10 lg:gap-20">
          {stats.map((stat, i) => (
            <div key={i} className="text-center lg:text-left">
              <div className="text-2xl sm:text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
                {stat.value}
              </div>
              <div className="text-white/70 text-xs sm:text-sm mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1 text-white/50 text-xs animate-bounce">
        <i className="ri-arrow-down-s-line text-2xl"></i>
      </div>
    </section>
  );
}
